import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SitesComponent } from './sites/sites.component';
import { PlanningFormComponent } from './planning-form/planning-form.component';
import { PlanningRouteListComponent } from './planning-route-list/planning-route-list.component';
import { UserActiveGuard } from 'src/app/core/guards/user-active.guard';
import { UserResolver } from 'src/app/core/resolves/user.resolve';
import { CriticZonesComponent } from './critic-zones/critic-zones.component';


const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'Rutas' },
    children: [
      {
        path: 'planning',
        data: { breadcrumb: 'Planeación' },
        children: [
          {
            path: 'form/:id',
            component: PlanningFormComponent,
            data: { breadcrumb: 'Detalle' },
            canActivate: [UserActiveGuard],
            resolve: {
              UserResolver
            },
          },
          {
            path: '',
            component: PlanningRouteListComponent,
            data: { breadcrumb: 'Listado' },
            canActivate: [UserActiveGuard],
            resolve: {
              UserResolver
            },
          },
          { path: '**', redirectTo: '/routes/planning' }
        ]
      },
      {
        path: 'sites',
        data: { breadcrumb: 'Puntos de control y Sitios autorizados' },
        component: SitesComponent,
        canActivate: [UserActiveGuard],
        resolve: {
          UserResolver
        },
      },
      {
        path: 'critic-zones',
        data: { breadcrumb: 'Zonas críticas' },
        component: CriticZonesComponent,
        canActivate: [UserActiveGuard],
        resolve: {
          UserResolver
        },
      },
      { path: '**', redirectTo: '/routes/planning' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoutesRoutingModule { }
